import type { DependencyList, EffectCallback } from 'react';
import { useEffect } from 'react';
import useIsFirstRender from './useIsFirstRender';
import { noop } from '../util/react-transition-component/lib/noop';

function useUpdateEffect(effect: EffectCallback, deps?: DependencyList): void {
  const isFirst = useIsFirstRender();

  useEffect(() => {
    if (!isFirst) {
      return effect();
    }
    return noop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useUpdateEffect;
